module.exports = __webpack_public_path__ + "static/media/caret-up.7ddd7460.svg";